import { decamelizeKeys } from "humps";
import { Typography } from "PFComponents/typography";
import { useCallback } from "react";

import css from "./object_display.module.scss";

export const ObjectDisplay = ({ object }: { object: object }) => {
  const parseValue = useCallback((value: string | object[]): string => {
    if (typeof value === "string") {
      return value;
    }
    return (value || []).map((item) => (typeof item === "string" ? item : JSON.stringify(item))).join("\n");
  }, []);

  const decamelizedObject = decamelizeKeys(object);

  return (
    <div className={css.wrapper}>
      {Object.keys(decamelizedObject).map((key) => (
        <Typography withMargin key={key} variant="bodyRegular">{`${key}: ${parseValue(
          decamelizedObject[key]
        )}`}</Typography>
      ))}
    </div>
  );
};
